<template>
  <span class="stock-status-label" :class="`stock-status-label--${state}`">
    {{ text }}
  </span>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    state() {
      return this.value.toLowerCase();
    },
    text() {
      switch (this.value) {
        case 'FINISHED':
          return '已兌換';
        case 'HOLDING':
          return '購買中';
        case 'AVAILABLE':
        default:
          return '可兌換';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.stock-status-label {
  display: inline-block;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;

  &--available {
    background: #bcfbdb;
    color: #1d7e1c;
  }

  &--finished {
    background: #ebeef0;
    color: #96a1ad;
  }

  &--holding {
    background: #feebd9;
    color: #ac6b2d;
  }
}
</style>
